import axios from '@/lib/axios';
import { PaymentTask, SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1001. 支払タスクアーカイブ解除
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id/unarchive
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const unarchivePaymentTask = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.id}/unarchive`,
    props
  );
};

export const useUnarchivePaymentTask = () => {
  return useMutation({
    mutationFn: unarchivePaymentTask,
  });
};
